/**
 * 日期格式化工具
 * 统一列表/详情页时间展示格式，避免各模块各自手写 pad 函数。
 */

function parseIsoParts(value) {
  if (value === null || value === undefined || value === '') return null
  const s = String(value).trim()
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/)
  if (!m) return null
  return {
    y: m[1],
    mo: m[2],
    d: m[3],
    h: m[4] || '00',
    mi: m[5] || '00',
    s: m[6] || '00',
  }
}

/**
 * 将日期格式化为 `yyyy-MM-dd HH:mm:ss`。
 * 兼容后端 LocalDateTime 经 Jackson 序列化的 ISO 字符串（如 `2026-07-08T10:03:38` 或带纳秒/时区）、
 * 前端 Date 对象、以及毫秒时间戳。
 *
 * @param {string|Date|number|null|undefined} value 待格式化的值
 * @param {string} [placeholder='—'] 空值或解析失败时的占位符
 * @returns {string}
 */
export function formatDateTime(value, placeholder = '—') {
  const parts = parseIsoParts(value)
  if (parts) {
    return `${parts.y}-${parts.mo}-${parts.d} ${parts.h}:${parts.mi}:${parts.s}`
  }
  if (value === null || value === undefined || value === '') return placeholder
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  const pad = (n) => String(n).padStart(2, '0')
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  )
}

/**
 * 将日期格式化为 `yyyy-MM-dd`（仅日期，不含时分秒）。
 *
 * @param {string|Date|number|null|undefined} value 待格式化的值
 * @param {string} [placeholder='—'] 空值或解析失败时的占位符
 * @returns {string}
 */
export function formatDate(value, placeholder = '—') {
  const parts = parseIsoParts(value)
  if (parts) return `${parts.y}-${parts.mo}-${parts.d}`
  if (value === null || value === undefined || value === '') return placeholder
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}
